<!-- <app-page-layout [showBreadcrumbs]="false">
    <div style="height: 100%; max-width: 958px;" class="layout vertical top left"
         >
        <div class="horizontal layout center middle" style="min-height: 80px; width: 100%; font-size: x-large;">
            <span style="font-weight: lighter;">Welcome Back,</span>&nbsp;<span>{{securityDataService.userProfile.name}}</span>
        </div>

        <div class="layout vertical left top" style="width: 100%; padding: 0 20px;">
            <div style="width: 100%; margin: 30px 10px 0 10px; font-size: large; color: #005a9e;" class="layout horizontal left middle">
                <app-icon id="security"></app-icon>
                IAM - Identity Access Management
            </div>
            <div class="layout horizontal left top" style="width: 100%; height: 100%;"> 
                <div class="layout horizontal left top" style="width: 100%; flex-wrap: wrap;"> 
                    <div class="tile"><app-dashboard-totalizer [iconId]="'account'" [counter]="25" [label]="'Users'" [caption]="'Manage Users'" url="/private/iam/user-profiles"></app-dashboard-totalizer></div>
                    <div class="tile"><app-dashboard-totalizer [iconId]="'account-group'" [counter]="12" [label]="'Groups'" [caption]="'Manage User Groups'" url="/private/iam/user-account-groups"></app-dashboard-totalizer></div>
                    <div class="tile"><app-dashboard-totalizer [iconId]="'shield-check'" [counter]="18" [label]="'Roles'" [caption]="'Manage Roles'" url="/private/iam/roles"></app-dashboard-totalizer></div>
                </div>
            </div>
        </div>

        <div class="layout vertical left top" style="width: 100%; padding: 0 20px;">
            <div style="width: 100%; margin: 30px 10px 0 10px; font-size: large; color: #005a9e;" class="layout horizontal left middle">
                <app-icon id="account"></app-icon>
                Subjects
            </div>
            <div class="layout horizontal left top" style="width: 100%; height: 100%;"> 
                <div class="layout horizontal left top" style="width: 100%; flex-wrap: wrap;"> 
                    <div class="tile"><app-dashboard-totalizer [iconId]="'account-heart'" [counter]="25" [label]="'Patients'" [caption]="'Manage Patients'"></app-dashboard-totalizer></div>
                    <div class="tile"><app-dashboard-totalizer [iconId]="'stethoscope'" [counter]="12" [label]="'Doctors'" [caption]="'Manage Doctors'"></app-dashboard-totalizer></div>
                    <div class="tile"><app-dashboard-totalizer [iconId]="'police'" [counter]="18" [label]="'Agents'" [caption]="'Manage Agents'"></app-dashboard-totalizer></div>
                </div>
            </div>
        </div>

        <div class="layout vertical left top" style="width: 100%; padding: 0 20px;">
            <div style="width: 100%; margin: 30px 10px 0 10px; font-size: large; color: #005a9e;" class="layout horizontal left middle">
                <app-icon id="hospital-box"></app-icon>
                Medical Management
            </div>
            <div class="layout horizontal left top" style="width: 100%; height: 100%;"> 
                <div class="layout horizontal left top" style="width: 100%; flex-wrap: wrap;"> 
                    <div class="tile"><app-dashboard-totalizer [iconId]="'account-heart'" [counter]="25" [label]="'Patients'" [caption]="'Manage Patients Tests'"></app-dashboard-totalizer></div> -->
                    <!-- <div class="tile"><app-dashboard-totalizer [iconId]="'microscope'" [counter]="12" [label]="'Unexamined\nTests'"></app-dashboard-totalizer></div> -->
                    <!-- <div class="tile"><app-dashboard-totalizer [iconId]="'microscope'" [counter]="12" [label]="'Tests'" [caption]="'Examine Tests'"></app-dashboard-totalizer></div>
                </div>
            </div>
        </div>
    </div>
</app-page-layout> -->

<app-page-layout>
    <div slot="body">
        <div style="height: 100%; max-width: 958px;" class="layout vertical top left">
            <div class="horizontal layout center middle" style="min-height: 80px; width: 100%; font-size: x-large;">
                <span style="font-weight: lighter;">Welcome Back,</span>&nbsp;<span>{{userFirstName}}</span>
            </div>
            <app-dashboard-menu></app-dashboard-menu>
        </div>
    </div>
</app-page-layout>
